import { render, staticRenderFns } from "./EntityProfile.vue?vue&type=template&id=77a80851"
import script from "./EntityProfile.vue?vue&type=script&lang=js"
export * from "./EntityProfile.vue?vue&type=script&lang=js"
import style0 from "./EntityProfile.vue?vue&type=style&index=0&id=77a80851&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports